import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  searchText: null,
  selectedStatus: null,
  dataEntradaInicial: null,
  dataEntradaFinal: null,
  comprador: [],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
